module.exports = __webpack_public_path__ + "static/media/map-figure-9-4.3973627c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/content/figures/m/map-figure-9-4.svg
// module id = 684
// module chunks = 0